import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modifylc_your_stopovers';
export const route = 'modifylc_your_stopovers/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modifylc_stopovers" */
/* webpackPrefetch: true */
'../components/StopOverSelectorLCPage')));